import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCameraFocus = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.75 7.125H8.057C8.31043 7.12502 8.55974 7.06083 8.78165 6.93843C9.00356 6.81602 9.19084 6.63938 9.326 6.425L9.86 5.577C9.99516 5.36262 10.1824 5.18598 10.4044 5.06357C10.6263 4.94116 10.8756 4.87697 11.129 4.877H12.871C13.1244 4.87697 13.3737 4.94116 13.5956 5.06357C13.8176 5.18598 14.0048 5.36262 14.14 5.577L14.674 6.425C14.8092 6.63938 14.9964 6.81602 15.2184 6.93843C15.4403 7.06083 15.6896 7.12502 15.943 7.125H17.25C17.6478 7.125 18.0294 7.28303 18.3107 7.56434C18.592 7.84564 18.75 8.22717 18.75 8.625V15.317C18.7489 15.7299 18.5845 16.1256 18.2925 16.4175C18.0006 16.7095 17.6049 16.8739 17.192 16.875H6.808C6.39512 16.8739 5.99945 16.7095 5.70749 16.4175C5.41554 16.1256 5.25106 15.7299 5.25 15.317V8.625C5.25 8.22717 5.40804 7.84564 5.68934 7.56434C5.97064 7.28303 6.35218 7.125 6.75 7.125V7.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 11.625C9.75 12.2217 9.98705 12.794 10.409 13.216C10.831 13.6379 11.4033 13.875 12 13.875C12.5967 13.875 13.169 13.6379 13.591 13.216C14.0129 12.794 14.25 12.2217 14.25 11.625C14.25 11.0283 14.0129 10.456 13.591 10.034C13.169 9.61205 12.5967 9.375 12 9.375C11.4033 9.375 10.831 9.61205 10.409 10.034C9.98705 10.456 9.75 11.0283 9.75 11.625V11.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 4.81C0.75 4.03159 1.05922 3.28506 1.60964 2.73464C2.16006 2.18422 2.90659 1.875 3.685 1.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 19.19C0.75 19.9684 1.05922 20.7149 1.60964 21.2654C2.16006 21.8158 2.90659 22.125 3.685 22.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.2499 4.81C23.2499 4.03159 22.9407 3.28506 22.3903 2.73464C21.8399 2.18422 21.0934 1.875 20.3149 1.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.2499 19.19C23.2499 19.9684 22.9407 20.7149 22.3903 21.2654C21.8399 21.8158 21.0934 22.125 20.3149 22.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCameraFocus.displayName = 'SvgCameraFocus';
export default SvgCameraFocus;
